import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
// import Chats from "../../services/chat.service";

export default class NewTicket extends Subscriber {
  state = {
    ticket: false
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("ticket").subscribe(ticket => {
        this.setState({
          ticket: ticket ? true : false
        });
      })
    );
  }

  render() {
    let content = "";
    if (!this.state.ticket) {
      content = (
        <div className="new_ticket">
          Please write a message to start the chat.
        </div>
      );
    }
    return content;
  }
}